import {Currency} from '../__generated__/resolvers-types';

export function formatCurrency(currency: Currency, amount: number): string {
  const formatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return formatter.format(amount);
}
